import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e77eafd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ant-upload-drag-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "ant-upload-drag-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-nova-imagem" }, "Arraste e solte suas Imagens aqui", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text ui-nova-imagem-descricao" }, "Para maior qualidade envie imagens no formato JPG e PNG com tamanhos padronizados.", -1))
const _hoisted_12 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ui-imagem" }
const _hoisted_15 = { class: "ui-daj-center" }
const _hoisted_16 = { class: "ui-definir-principal" }
const _hoisted_17 = { class: "ui-move ui-ordenar-imagem" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: "Imagens" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selecionarImagemUpload && _ctx.selecionarImagemUpload(...args))),
                  class: "ant-upload ant-upload-drag",
                  onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_4, [
                    _createElementVNode("input", {
                      id: "selecionarImagemProduto",
                      type: "file",
                      accept: ".png, .jpg, .jpeg, .webp",
                      multiple: "",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enviarImagens && _ctx.enviarImagens(...args))),
                      style: {"display":"none"}
                    }, null, 32),
                    _createElementVNode("div", {
                      class: "ant-upload-drag-container",
                      onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dropImagem && _ctx.dropImagem(...args)))
                    }, [
                      ((_ctx.state.enviandoImagens || _ctx.state.excluindoImagens))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("p", _hoisted_6, [
                              _createVNode(_component_a_spin, { size: "large" })
                            ]),
                            _hoisted_7
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, [
                              _createVNode(_component_icone, {
                                style: {"font-size":"40px"},
                                nome: "upload-nuvem"
                              })
                            ]),
                            _hoisted_10,
                            _hoisted_11
                          ]))
                    ], 32)
                  ])
                ], 32)
              ])
            ]),
            ((_ctx.computedImagens.length > 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_image_preview_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_draggable, {
                          modelValue: _ctx.computedImagens,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedImagens) = $event)),
                          "item-key": "imagem",
                          handle: ".ui-move",
                          class: _normalizeClass(_ctx.computedImagens.length > 9?'ui-daj-center ui-imagens':'ui-imagens'),
                          onEnd: _cache[6] || (_cache[6] = ($event: any) => (_ctx.organizarImagens(true)))
                        }, {
                          item: _withCtx(({element}) => [
                            _createElementVNode("span", _hoisted_14, [
                              _createVNode(_component_a_image, {
                                width: 105,
                                height: 105,
                                src: element.imagem
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_15, [
                                (element.principal)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      title: "Imagem Principal",
                                      color: "yellow",
                                      placement: "bottom"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", _hoisted_16, [
                                          _createVNode(_component_icone, { nome: "estrela" })
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_tooltip, {
                                  title: "Ordenar",
                                  placement: "bottom"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", _hoisted_17, [
                                      _createVNode(_component_icone, { nome: "draggable" })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                (element.principal === false)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 1,
                                      title: "Definir como principal",
                                      color: "yellow",
                                      placement: "bottom"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.defineImagemPrincipal(element.imagem)),
                                          class: "ui-definir-principal"
                                        }, [
                                          _createVNode(_component_icone, { nome: "favorito" })
                                        ], 8, _hoisted_18)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_tooltip, {
                                  title: "Remover",
                                  color: "red",
                                  placement: "bottom"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", {
                                      title: "Remover",
                                      onClick: ($event: any) => (_ctx.confirmaExclusao(element)),
                                      class: "ui-remover-imagem"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_19)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}